import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { MigrationSet, useSmokeballApp } from "../shared";
import log from "../shared/utils/log";
import { requestHelper } from "../shared/utils";

const fetchNewMigration = async ({
  accountId,
  token,
}: {
  accountId: string;
  token?: () => Promise<string>;
}): Promise<MigrationSet> => {
  const endpoint = `/init`;
  const data = await requestHelper(
    accountId,
    endpoint,
    "Failed to initialise new import.",
    "POST",    
    token,
  );
  log("New import data: ", data);

  return data;
};

export const useNewMigration = () => {
  const { auth, context } = useSmokeballApp();
  const navigate = useNavigate();
  const { mutateAsync, isLoading } = useMutation(fetchNewMigration);
  const accountId = context?.firmId || "";
  const token = auth?.token;

  const handleNewMigrationClick = async () => {
    const result = await mutateAsync({ accountId, token });
    navigate(`workflow/${result.migrationSetId}`);
  };

  return {
    handleNewMigrationClick,
    isLoading,
  };
};
